// loginpage
import axios from "axios";
import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
// css
import "../../css/style.css";
import theme from "../../css/theme";

import { useDispatch } from "react-redux";
import { authLoginSucces } from "../../store/actions/auth";
import { useNavigate } from "react-router-dom";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";

import AccountCircle from "@mui/icons-material/AccountCircle";

const UserLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = React.useState(false);

  const endDateSponsori = 1781034114000;

  const handleUserChange = event => {
    setUser(event.target.value);
  };

  const handlePasswordChange = event => {
    setPassword(event.target.value);
  };

  const onLogin = async () => {
    false && console.log(`saved user: ${user} si parola: ${password}`);

    axios
      .post(`/api/public/login`, { user_name: user, user_password: password })
      .then(response => {
        dispatch(authLoginSucces(response.data.user_id, response.data.user_name, response.data.user_type));
        const user_id = response.data.user_id;
        const user_type = response.data.user_type;

        if (user_type === "admin") {
          navigate("/edituser");
        } else if (user_type === "echipa") {
          navigate("/members/" + user_id);
        } else {
          console.error(`User sau parola incorecte`);
        }
      })
      .catch(error => {
        console.error(`Axios error /api/public/login : `, error);
      });
  };

  const onHome = () => {
    navigate("/");
  };

  const handleClickShowPassword = () => setShowPassword(show => !show);

  const [currentTime, setCurrentTime] = React.useState(+new Date());

  React.useEffect(() => {
    setTimeout(() => {
      setCurrentTime(+new Date());
    }, 5000);
  }, [currentTime]);

  return (
    <div className="edit-member-container">
      <div className="text-fields login-page">
        <FormControl variant="standard">
          <TextField
            className="textfield"
            required
            id="outlined-required-user"
            label="User"
            name="user"
            onChange={handleUserChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
          />
        </FormControl>

        <FormControl variant="standard">
          <TextField
            className="textfield"
            required
            id="outlined-required-pass"
            label="Password"
            name="password"
            type={showPassword ? "text" : "password"}
            onChange={handlePasswordChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
      </div>
      <div className="login-buttons">
        {currentTime > endDateSponsori && (
          <div className="timer-message">Inscrierile pentru Cursa Sponsorilor au luat sfarsit</div>
        )}
        <div className="login-page-buttons">
          <div className="login-page">
            <Button
              className="admin-buttons"
              variant="contained"
              theme={theme}
              type="submit"
              onClick={onLogin}
              disabled={currentTime > endDateSponsori}
            >
              Login
            </Button>

            <Button className="admin-buttons" variant="contained" theme={theme} type="submit" onClick={onHome}>
              Acasa
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserLogin;
